import { render, staticRenderFns } from "./cjfw_service.vue?vue&type=template&id=2c2a04aa&scoped=true"
import script from "./cjfw_service.vue?vue&type=script&lang=js"
export * from "./cjfw_service.vue?vue&type=script&lang=js"
import style0 from "./cjfw_service.vue?vue&type=style&index=0&id=2c2a04aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2a04aa",
  null
  
)

export default component.exports